import angular from "angular";

import BicycleOwnerNotificationsModuleRouting from "./bicycle-owner-notifications.module.routing";

export default angular
  .module("vt-bicycle-owner-notifications", [])
  .config(BicycleOwnerNotificationsModuleRouting);
